import * as React from "react"

const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M8.5 6C7.94772 6 7.5 6.44772 7.5 7L7.5 20C7.5 20.5523 7.94772 21 8.5 21L18.4999 21C19.0522 21 19.4999 20.5523 19.4999 20L19.4999 7C19.4999 6.44771 19.0522 6 18.4999 6L8.5 6Z"
			stroke="#7D828C"
			strokeWidth="2"
			strokeLinejoin="round"
		/>
		<path
			d="M5.5 18C5.5 18.5523 5.05229 19 4.5 19C3.94772 19 3.5 18.5523 3.5 18L5.5 18ZM16.4999 2C17.0522 2 17.4999 2.44771 17.4999 3C17.4999 3.55228 17.0522 4 16.4999 4L16.4999 2ZM5.5 4L5.5 18L3.5 18L3.5 4L5.5 4ZM16.4999 4L5.5 4L5.5 2L16.4999 2L16.4999 4ZM3.5 4C3.5 2.89543 4.39543 2 5.5 2L5.5 4L5.5 4L3.5 4Z"
			fill="#7D828C"
		/>
	</svg>
)

export default CopyIcon
